import React, { useState, useEffect } from "react";
import "./SingleRegionSelectField.scss";
import GetFetch from "../../hooks/GetFetch";
import { LoadingIndicatorCircle } from "../Loading";
import { BaseSelectField } from "../BaseSelectField/BaseSelectField";
import ClosingAlert from "../ClosingAlert";
import IsNullOrEmpty from "../IsNullOrEmpty";

/**
 * @param {Object} props
 * @param {boolean} [props.enableSearch] Allows text box for search input for regions
 * @param {boolean} [props.isVisible] Shows/Hides Select Box
 * @param {boolean} [props.readOnly] Enables/Disables Select Box (Makes 'readonly')
 * @param {string} [props.label] Displays 'title' on Select Box
 * @param {(value: any) => void} [props.optionUpdatedByUser] 
 * @param {(value: any) => boolean | string} [props.validationMethod] Not implemented
 * @param {Object} [props.inputAttribute] can be used for 508 HTML tags
 * @param {any} [props.value] current selection of select box
 */
const SingleRegionSelectField = (
    {
        enableSearch,
        isVisible,
        readOnly=false,
        label, 
        optionUpdatedByUser,
        validationMethod,
        inputAttribute,
        value
    }
) => {
    const [regions, setRegions] = useState();
    const [loading, setLoading] = useState();
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setError(false);
        setRegions(null);
        setLoading(true);
        const result = await GetFetch('/v1/Region');
        const { Success, Message, Errors } = result;
        if (Success) {
            const regionNumbers = Message.map(({RegionNumber}) => RegionNumber);
            regionNumbers.sort((a, b) => a - b);
            
            setError(false);
            setRegions(regionNumbers);
        }
        else {
            setError(true);
            if (Errors[0].Message === "No records found at the moment") {
                setErrorMessage("Something went wrong. Please contact your administrator.");
            }
            else {
                setErrorMessage(Errors[0].Message);
            }
        }
        setLoading(false);
    };

    return (
        <>
            {
                loading && 
                <span className="inline__span--wrapper">
                    <LoadingIndicatorCircle message="Loading available regions..." />
                </span>
            }
            {
                regions && 
                (
                    <BaseSelectField
                        inputAttribute={inputAttribute}
                        data={regions}
                        enableSearch={enableSearch}
                        isVisible={isVisible}
                        readOnly={readOnly}
                        label={label}
                        onInitialized={(e) => e.component.validate()}
                        onOptionChanged={(e) => e.component.validate()}
                        optionUpdatedByUser={optionUpdatedByUser}
                        validationRuleCallback={() => !IsNullOrEmpty(value)}
                        value={value} 
                    />
                )
            }
            <ClosingAlert
                enableAlertIcon={true}
                clickableIcon={() => { 
                    setError(false);
                    setErrorMessage(null);
                }}
                message={errorMessage}
                severity="warning"
                visible={error}
            />
        </>
    );
};

export default SingleRegionSelectField;